import {useFocusOnRouteChange} from '@/hooks/useFocusOnRouteChange'

export function RouteChangeFocusManager() {
    useFocusOnRouteChange()
    return null
}
